const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-localization",
    meta: {},
    name: "m-localization",
    component: () => import("@/modules/mlocalization/RootView")
});

export default Routes;